import type { SendResultsRecipient } from '../types/sendResults';

// Stage 6A v5 §2.5 — preview-only page-view filter for the recipient table.
// Multi-select, ANDs with the channel/status/engagement filters. "No views" is
// deliberately email-scoped: SMS sends point to a contact summary page, not a
// previewLink, so a zero-view SMS row isn't a meaningful "didn't open the
// preview" signal (v5 Q4 / §2.5).

export type PageViewFilter = 'has_views' | 'no_views' | 'multiple_views';

export const PAGE_VIEW_FILTER_OPTIONS: { value: PageViewFilter; label: string }[] = [
  { value: 'has_views', label: 'Has views' },
  { value: 'no_views', label: 'No views' },
  { value: 'multiple_views', label: 'Multiple views' },
];

export type PageViewFields = Pick<SendResultsRecipient, 'channel' | 'pageViewCount'>;

export function matchesPageViewFilter(r: PageViewFields, filter: PageViewFilter): boolean {
  const v = r.pageViewCount ?? 0;
  switch (filter) {
    case 'has_views':
      return v > 0;
    case 'no_views':
      return r.channel === 'email' && v === 0;
    case 'multiple_views':
      return v > 1;
  }
}

// AND across the active set; empty set matches everything.
export function matchesAllPageViewFilters(r: PageViewFields, active: PageViewFilter[]): boolean {
  return active.every((f) => matchesPageViewFilter(r, f));
}
